module.exports = __webpack_public_path__ + "img/宣传_148.959b8974.jpg";